import { Component, OnInit } from '@angular/core';
import { SwiperConfigInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { Subscription } from 'rxjs/Subscription';
import { BroadcastMessageService } from '../../../services/broadcastMessageService';
import { AppService } from '../../../app/app.service';
import { PageContentService } from '../../../services/pagecontent.service';
import { Settings, AppSettings } from '../../../app/app.settings';

@Component({
    selector: 'app-testimonials',
    templateUrl: './testimonials.component.html',
    styleUrls: ['./testimonials.component.scss'],
     providers: [PageContentService]
})
export class TestimonialsComponent implements OnInit {
    public settings: Settings;
    public latestnews;
    public langId: number;
    projectList: [];

    subscription: Subscription
    public config: SwiperConfigInterface = {};
    private pagination: SwiperPaginationInterface = {
        el: '.swiper-pagination',
        clickable: true
    };

    constructor(public appService: AppService, public pageservice: PageContentService,
        private broadcastMessageService: BroadcastMessageService,
        public appSettings: AppSettings, ) {
        this.settings = this.appSettings.settings;
        this.subscription = this.broadcastMessageService.getMessage().subscribe(message => {
            this.langId = +message.text;
            this.pageservice.getAllLatestNews(this.langId).subscribe(result => {
                
                if (result != null && result != undefined) {
                    this.latestnews = result;
                }
            });
        });
    }


    ngOnInit() {
        this.langId = this.settings.langId;
        this.pageservice.getAllLatestNews(this.langId).subscribe(result => {
            if (result != null && result != undefined) {
                this.latestnews = result;
            }
        });
        // this.pageservice.getAdvertisementList(this.langId).subscribe(result => {
            this.pageservice.getPublicationList(this.langId).subscribe(result => {
            if (result != null && result != undefined) {
                this.projectList = result.filter(item => item.title === 'Documents');
            }
        });


        (<any>window).twttr.widgets.load();
      
    }

    ngAfterViewInit() {
        this.config = {
            observer: true,
            slidesPerView: 1,
            spaceBetween: 0,
            keyboard: true,
            navigation: true,
            pagination: this.pagination,
            grabCursor: true,
            loop: false,
            preloadImages: false,
            lazy: true,
            // breakpoints: {
            //   480: {
            //     slidesPerView: 1
            //   },
            //   740: {
            //     slidesPerView: 2,
            //   },
            //   960: {
            //     slidesPerView: 3,
            //   }
            // }
        }

        let ngJs: any;
        const ngFjs = document.getElementsByTagName('script')[0];
        const ngP = 'https';

        if (!document.getElementById('twitter-wjs')) {
            ngJs = document.createElement('script');
            ngJs.id = 'twitter-wjs';
            ngJs.src = ngP + '://platform.twitter.com/widgets.js';
            ngFjs.parentNode.insertBefore(ngJs, ngFjs);

            
        }
       
    }

}
